export function formatPhone(value, event) {
  try {
    if (!value) { return '' }
    value = String(value.replace(/\s/g, ''))

    if (event.request.settings.shopLang == 'de') {
      if (value.startsWith('0049')) { 
        value = value.replace('0049', '+49') 
      } 
      else if (value.startsWith('015')) {
        value = value.replace('015', '+4915')
      }
      else if (value.startsWith('016')) {
        value = value.replace('016', '+4916')
      }
      else if (value.startsWith('017')) {
        value = value.replace('017', '+4917')
      }
    } else {
      if (value.startsWith('0031')) { value = value.replace('0031', '+31') }
      else if (value.startsWith('06')) {
        value = value.replace('06', '+316')
      }
    }
    
    return value
  }
  catch {
    return ''
  }
}

export function getCategoryFromTitle(productTitle, event) {
  const translations = {
    'Woonartikelen': {
      'nl': 'Woonartikelen',
      'de': 'dekoration'
    },
    'buiten': {
      'nl': 'buiten',
      'de': 'outdoor'
    },
    'tuin': {
      'nl': 'tuin',
      'de': 'garten'
    },
    'kleed': {
      'nl': 'kleed',
      'de': 'teppich'
    },
    'Buitenkleden': {
      'nl': 'Buitenkleden',
      'de': 'Outdoor teppiche'
    },
    'kind': {
      'nl': 'kind',
      'de': 'kinder'
    },
    'speel': {
      'nl': 'speel',
      'de': 'spiel'
    },
    'Kinderkleed': {
      'nl': 'Kinderkleed',
      'de': 'Kinderteppiche'
    },
    'Vloerkleden': {
      'nl': 'Vloerkleden',
      'de': 'Teppiche'
    }
  }
  try {
    function localT(title) {
      return translations[title][event.request.settings.shopLang]
    }
    const title = productTitle.toLowerCase()
    let category = localT('Woonartikelen')
    if ((title.includes(localT('buiten')) || title.includes(localT('tuin'))) && title.includes(localT('kleed'))) {
      category = localT('Buitenkleden')
    }
    else if (title.includes(localT('kind')) || title.includes(localT('speel'))) {
      category = localT('Kinderkleed')
    }
    else if (title.includes(localT('kleed'))) {
      category = localT('Vloerkleden')
    }
    return category
  }
  catch {
    return ''
  }
}

export function totalTaxFromOrder(value) {
  let totalTax = 0
  for (let index = 0; index < value.length; index++) {
    const element = value[index];
    totalTax += element.amount
  }
  return totalTax
}

export function totalTaxFromOrderZaraz(value) {
  let totalTax = 0
  const taxRates = Object.values(value)
  for (let index = 0; index < taxRates.length; index++) {
    const element = taxRates[index];
    totalTax += element.amount
  }
  return totalTax
}

export function embeddedProductToJSON(value, index, event) {
  try {
    return JSON.stringify(value.map(product => {
      return {
        id: selectProductId({
          id: product.variant.resource.id,
          sku: product?.sku
        }, event.request.settings.config.analyticsProductIdType),
        item_id: selectProductId({
          id: product.variant.resource.id,
          sku: product?.sku
        }, event.request.settings.config.analyticsProductIdType),
        item_name: product.productTitle,
        currency: "EUR",
        discount: product.discountIncl,
        index: index,
        item_brand: product.brandTitle,
        item_variant: product.variant.resource.id,
        va: product.variantTitle,
        price: product.basePriceIncl,
        quantity: product.quantityOrdered,
        item_category: getCategoryFromTitle(product.productTitle, event)
      }
    }))
  }
  catch {
    return JSON.stringify([])
  }
}

export function selectProductId(vars, analyticsProductIdType) {
  switch (analyticsProductIdType) {
    case 'id':
      return vars.id
    case 'sku':
      return vars.sku
    default:
      return vars.id
  }
}